import { SensitiveSkin } from "./v1";

export const sensitiveSkinOptions = Object.entries(SensitiveSkin)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
